
import LargeModal from "components/elements/LargeModal";

// import {
//     CLIENT_BROADCASTER,
//     CONTENT_TYPES,
//     LS_CLONE_SUB_KEY,
//     SUB_MODIFY_TYPES,
//     SUB_MODIFY_TYPES_REVERSE,
// } from "core/Constants";
import dataProvider from "core/DataProvider";
import { toast } from "react-hot-toast";
import { useEffect, useState, useCallback } from "react";
import "../../../styles/group_tab.css";

const GroupSpotRenewForm = props => {
    //console.log(Object.values(props));
    // const [isEditing, setIsEditing] = useState(false);


    const onClose = (action = null) => {
        if (props.onClose !== undefined) {
            props.onClose(action);
        }
    };
    const headerMap = {
        new_spot: "Spots",
        remark: "Remark",
        sow_no: "SOW NO"
    };
    const [groupspotlist, setGroups] = useState([]);
    //const [search, setSearch] = useState("");
    //  const [loading, setLoading] = useState(true);
    const loadGroupsSpotList = useCallback(async () => {
        try {
            let response = await dataProvider.network.get("client/getGroupSpotlog/" + props.data.gid);

            let raw = response.spots_log_master;
            let parsedOnce = JSON.parse(raw);
            let groupspotlistRow = typeof parsedOnce === "string" ? JSON.parse(parsedOnce) : parsedOnce;
            // console.log("22", groupspotlistRow);
            if (!Array.isArray(groupspotlistRow)) {
                throw new Error("Parsed spots_log_master is not an array");
            }
            const groupspotlists = groupspotlistRow.map((x) => ({
                ...x,
                new_spot: x.allocated_spots,
                remark: x.remark,
                sow_no: x.swo_no,
            }));
            console.log("API groupspotlists:", groupspotlists);
            setGroups(groupspotlists);
        } catch (error) {
            toast.error("Failed to load groups spot log");
        }
    }, [props.data.gid]);
    //const grp_log_data = [];

    //const now = new Date();
    const [formDataPopup, setFormData] = useState({ grp_new_spot: "", group_remark: "", sow_no: "" });
    const [errors, setErrors] = useState({});

    const validate = () => {
        let newErrors = {};
        //console.log('tttt', formData.group_spot);
        // Static Fields Validation
        if (!formDataPopup.grp_new_spot || !formDataPopup.grp_new_spot) newErrors.grp_new_spot = "New Spots is required";
        if (!formDataPopup.group_remark || !formDataPopup.group_remark) newErrors.group_remark = "Enter Remark";
        // if (!formDataPopup.sow_no || !formDataPopup.sow_no.trim()) newErrors.sow_no = "SOW No is required";

if (formDataPopup.grp_new_spot < 1) newErrors.grp_new_spot = "Spot must be greater then 0";
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            // handleTabClick("tab1");
            return false;
        } else {
            return Object.keys(newErrors).length === 0; // Return true if no errors
        }
    };
    const handleInputChange = (e) => {
        setFormData({ ...formDataPopup, [e.target.name]: e.target.value });
    };
    const handleGrpNewFormSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) {
            //group/renew_spots/

            return;
        } else {
            let data = {
                payload: JSON.stringify({
                    group_id: props.data.gid,
                    allocated_spots: parseInt(formDataPopup.grp_new_spot, 10), // Convert to integer
                    remark: formDataPopup.group_remark,
                    swo_no: formDataPopup.sow_no,
                    created_date: new Date(),

                })
            };

            try {
                const response = await dataProvider.network.post("group/renew-spots", data);
                // console.log("API Response:", response);

                if (response.status === 200 || response.status === 201 || response.status === true) {
                    toast.success("Updated successfully!");
                    setTimeout(() => {
                        onClose("success");

                        //     navigate("/clients/renewList");  // Change '/success' to your desired path
                    }, 1000);

                } else {
                    toast.error("Renewal failed!");
                }
            } catch (error) {
                //console.error("API Error:", error);
                toast.error("Failed to form submit");
            }

        }

    };
    useEffect(() => {
        loadGroupsSpotList();
    }, [loadGroupsSpotList]);
    return (
        <LargeModal onClose={onClose}>

            <div className="flex flex-v-center">
                <h1>Addendum :- {props.data.grp_heading}</h1>
                <div className="right flex">

                </div>
            </div>
            <div className="flex sub-preview-wrapper">
                <div className="sub-preview-details">
                    <div className="table-wrapper">
                        <div className="table-data-grp" >
                            <form onSubmit={handleGrpNewFormSubmit}>

                                <div className="mtop table-data">
                                    <table>
                                        <thead>
                                            <tr>
                                                {Object.values(headerMap).map((head, idx) => (
                                                    <th key={idx}>{head}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                Object.values(groupspotlist).map((row, idx) => (
                                                    <tr key={idx}>

                                                        <td >{row['allocated_spots']}</td>
                                                        <td >{row['remark']}</td>
                                                        <td >{row['swo_no']}</td>

                                                    </tr>
                                                ))
                                            }


                                            {/* Fixed Row at End */}
                                            <tr>
                                                <td>
                                                    <input placeholder="Enter New Spots"
                                                        name="grp_new_spot" onChange={handleInputChange}
                                                        value={formDataPopup.grp_new_spot} min="1"
                                                    />
                                                    <p>{errors.grp_new_spot && <span className="errorDisplayPopup">{errors.grp_new_spot}</span>}</p>
                                                </td>
                                                <td>
                                                    <input
                                                        placeholder="Enter Remark"
                                                        name="group_remark" onChange={handleInputChange}
                                                        value={formDataPopup.group_remark}
                                                    />
                                                    <p>{errors.group_remark && <span className="errorDisplayPopup">{errors.group_remark}</span>}</p>
                                                </td>
                                                <td>
                                                    <input
                                                        placeholder="Enter SOW NO"
                                                        name="sow_no" onChange={handleInputChange}
                                                        value={formDataPopup.sow_no}
                                                    />
                                                    <p>{errors.sow_no && <span className="errorDisplayPopup">{errors.sow_no}</span>}</p>
                                                </td>
                                            </tr> </tbody>
                                    </table>
                                </div>
                                <button className="tab-button-grp" type="submit">Submit</button>
                                <button type="button" className="tab-button-bck" onClick={onClose}>Cancel</button>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </LargeModal>
    );
};

export default GroupSpotRenewForm;
